import React from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import styled from "styled-components";
import {
    Table,
    TableCell,
    TableRow,
    TableBody,
    Button,
    Typography,
} from "@material-ui/core";
import {
    setWeekCount,
    incrementWeekStart,
    decrementWeekStart,
} from "./actions";
import { selectWeekCount, selectSelectedJobpackProfile } from "./selectors";
import MapContainer from "./MapContainer";
const JobpackInfoContainer = styled.div`
    grid-row: 2;
    grid-column: 1;
    width: 100%;
    height: 80%;
    display: grid;
    overflow: hidden;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
    margin-top: 10px;
`;

const InfoBoxContainer = styled.div`
    grid-column: ${(props) => props.column};
    border: 1px solid #0188cc;
    background-color: #0188cc;
    border-radius: 4px;
    display: grid;
    grid-template-rows: 35px auto;
    overflow: hidden;
`;

const InfoBoxContent = styled.div`
    grid-row: 2;
    background-color: white;
    padding: 10px;
    overflow: scroll;
`;

const InfoBoxMap = styled.div``;

const InfoBoxHeader = styled.div`
    grid-row: 1;
    display: inline-block;
    color: white;
    padding-left: 12px;
    padding-top: 5px;
    font-size: 1.1em;
    font-family: "Nunito Sans", -apple-system, ".SFNSText-Regular",
        "San Francisco", BlinkMacSystemFont, "Segoe UI", "Helvetica Neue",
        Helvetica, Arial, sans-serif;
`;

class JobpackInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
        };
    }
    getAssignedRow = (assignedObject, label) => {
        return (
            (Array.isArray(assignedObject) &&
                assignedObject.map((e, i) => {
                    return (
                        <TableRow key={i}>
                            <TableCell component="th" scope="row">
                                Assigned {label}
                                {" " + (i + 1)}
                            </TableCell>
                            <TableCell align="right">{e.user_name}</TableCell>
                        </TableRow>
                    );
                })) || (
                <TableRow>
                    <TableCell component="th" scope="row">
                        Assigned {label}
                    </TableCell>
                    <TableCell align="right">{assignedObject}</TableCell>
                </TableRow>
            )
        );
    };

    render() {
        const { jobpackProfile } = this.props;
        const { show } = this.state;
        return (
            <div>
                <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    style={{
                        background: "#0188cc",
                        marginTop: "10px",
                    }}
                    onClick={() => this.setState({ show: !show })}
                >
                    <Typography
                        style={{
                            color: "white",
                        }}
                    >
                        Show {show ? "less" : "more"}
                    </Typography>
                </Button>
                {show && (
                    <JobpackInfoContainer>
                        <InfoBoxContainer column={1}>
                            <InfoBoxHeader>Jobpack Info</InfoBoxHeader>
                            <InfoBoxContent>
                                <Table style={{ width: "90%" }}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Jobpack Name
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.job_name}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Client Name
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.client_name}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Description of Works
                                            </TableCell>
                                            <TableCell align="right">
                                                {
                                                    jobpackProfile.description_of_works
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Job Type
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.job_type}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Start Date
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.start_date}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                End Date
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.end_date}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </InfoBoxContent>
                        </InfoBoxContainer>
                        <InfoBoxContainer column={2}>
                            <InfoBoxHeader>Assignees</InfoBoxHeader>
                            <InfoBoxContent>
                                <Table>
                                    <TableBody>
                                        {this.getAssignedRow(
                                            jobpackProfile.assigned_manager,
                                            "Manager"
                                        )}
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Assigned Supervisor
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.assigned_supervisor
                                                    ? jobpackProfile
                                                          .assigned_supervisor
                                                          .user_name
                                                    : "N/A"}
                                            </TableCell>
                                        </TableRow>
                                        {this.getAssignedRow(
                                            jobpackProfile.assigned_operatives,
                                            "Operatives"
                                        )}
                                    </TableBody>
                                </Table>
                            </InfoBoxContent>
                        </InfoBoxContainer>
                        <InfoBoxContainer column={3}>
                            <InfoBoxHeader>Assigned Vehicles</InfoBoxHeader>
                            <InfoBoxContent>
                                <Table>
                                    <TableBody>
                                        {Array.isArray(
                                            jobpackProfile.job_vehicles
                                        ) &&
                                            jobpackProfile.job_vehicles.map(
                                                (e, i) => {
                                                    return (
                                                        <TableRow key={i}>
                                                            <TableCell align="right">
                                                                {e.machine_desc}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {e.machine_reg}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                }
                                            )}
                                        {!Array.isArray(
                                            jobpackProfile.job_vehicles
                                        ) && (
                                            <TableRow>
                                                <TableCell align="right">
                                                    No Vehicles In Use
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </InfoBoxContent>
                        </InfoBoxContainer>
                        <InfoBoxContainer column={4}>
                            <InfoBoxHeader>Map</InfoBoxHeader>
                            <InfoBoxContent>
                                <InfoBoxMap>
                                    <MapContainer
                                        lat={jobpackProfile.location_lat}
                                        long={jobpackProfile.location_long}
                                    />
                                </InfoBoxMap>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                Address
                                            </TableCell>
                                            <TableCell align="right">
                                                {jobpackProfile.address}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </InfoBoxContent>
                        </InfoBoxContainer>
                    </JobpackInfoContainer>
                )}
            </div>
        );
    }
}

export default hot(module)(
    connect(
        (store) => {
            return {
                weekCount: selectWeekCount(store),
                jobpackProfile: selectSelectedJobpackProfile(store),
            };
        },
        { setWeekCount, incrementWeekStart, decrementWeekStart }
    )(JobpackInfo)
);
